import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { NgModule } from '@angular/core';

export function minlengthValidationMessage(err, field) {
  return `Minstens ${field.templateOptions.minLength} karakters vereist!`;
}

export function maxlengthValidationMessage(err, field) {
  return `Maximum ${field.templateOptions.maxLength} karakters toegelaten`;
}

export function minValidationMessage(err, field) {
  return `Waarde moet groter of gelijk zijn aan: ${field.templateOptions.min}.`;
}

export function maxValidationMessage(err, field) {
  return `Waarde moet kleiner of gelijk zijn aan: ${field.templateOptions.max}.`;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormlyModule.forRoot({
      extras: { lazyRender: true },
      validationMessages: [
        { name: 'required', message: 'Dit veld is verplicht!' },
        { name: 'minlength', message: minlengthValidationMessage },
        { name: 'maxlength', message: maxlengthValidationMessage },
        { name: 'min', message: minValidationMessage },
        { name: 'max', message: maxValidationMessage }
      ]
    })
  ]
})
export class FormlyRootModule {}
